import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { StockCollectionHistoryAction } from './stock-collection-history.actions';
import {
  StockCollectionHistoryListContent,
  StockCollectionHistorySearchCriteria,
  StockCollectionHistoryViewResponse
} from '../../model/stock-collection-history.model';

export interface StockCollectionHistoryState extends EntityState<StockCollectionHistoryListContent> {
  isLoading: boolean;
  selected: StockCollectionHistoryListContent[];
  criteriaObject: StockCollectionHistorySearchCriteria;
  totalElements: number;
  totalPages: number;
  auditLogs: any;
  viewResponse: StockCollectionHistoryViewResponse;
}

export const adapter: EntityAdapter<StockCollectionHistoryListContent> =
  createEntityAdapter<StockCollectionHistoryListContent>({
    selectId: (model: StockCollectionHistoryListContent) => model.recallNo
  });

export const initialState: StockCollectionHistoryState = adapter.getInitialState({
  isLoading: false,
  selected: [],
  criteriaObject: {
    page: 0,
    size: 20
  },
  totalElements: null,
  totalPages: 20,
  auditLogs: [],
  viewResponse: null
});

export const StockCollectionHistoryReducer = createReducer<StockCollectionHistoryState>(
  initialState,
  on(StockCollectionHistoryAction.responseList, (state, action): StockCollectionHistoryState => {
    return {
      ...state,
      selected: action.data.content,
      totalElements: action.data.totalElements,
      isLoading: false,
      criteriaObject: {
        ...state.criteriaObject,
        page: action.data.page,
        size: action.data.size
      }
    };
  })
);
